import { createNamespacedHelpers } from 'vuex';

const historyImagesMapper = createNamespacedHelpers('history/image');
const historyModelsMapper = createNamespacedHelpers('history/model');
const GOOD_CLASS = '0';

export default {
	name: 'ImageModal',

	props: {
		selectedImage: {
			type: Object,
			default: () => {},
		},

		modalId: {
			type: String,
		},
	},

	data() {
		return { GOOD_CLASS: GOOD_CLASS };
	},

	watch: {
		'selectedImage.isRetraining'(newval) {
			console.log({ newval });
		},
	},

	computed: {
		...historyModelsMapper.mapState(['trainable']),
	},

	methods: {
		...historyImagesMapper.mapActions(['setIsTraning']),
		...historyImagesMapper.mapMutations(['SET_RETRAIN']),

		closeModal() {
			this.$bvModal.hide(this.modalId);
		},

		onRetrain() {
			this.setIsTraning({
				id: this.selectedImage?._id?.$oid,
				isRetraining: true,
			});

			this.selectedImage.isRetraining=true
			this.$forceUpdate();
			this.$eventBus.$emit('force-update');
		},

		shown() {
			this.$forceUpdate();
		},
	},

	mounted() {},
};
